import { DATE_FORMAT } from "helpers/common";
import React from "react";
const STATUS = {
  active: "Active",
  inactive: "Inactive",
  blocked: "Blocked",
  deleted: "Deleted",
  pending: "Pending",
};
const Columns = ({ currentPage, pageSize, unarchiveHandler }) => {
  return [
    {
      dataField: "",
      text: "SrNo",
      formatter: (cell, row, rowIndex) => (
        <span className="text-capitalize cursor-pointer">
          {(currentPage - 1) * pageSize + (rowIndex + 1)}
        </span>
      ),
    },

    {
      dataField: "first_name",
      text: "Name",
      formatter: (_, row) => (
        <span className="text-capitalize cursor-pointer">{row.full_name}</span>
      ),
    },
    {
      dataField: "doctor_code",
      text: "Doctor Code",
      formatter: (_, row) => (
        <span className="text-capitalize cursor-pointer">
          {row.doctor_code}
        </span>
      ),
    },
    {
      dataField: "email1",
      text: "Email",
      formatter: (_, row) => (
        <span className="text-capitalize cursor-pointer">
          {row?.email || "--"}
        </span>
      ),
    },
    {
      dataField: "patient_code",
      text: "Patient Code",
      formatter: (_, row) => (
        <span className="text-capitalize cursor-pointer">
          {row?.patient_code || "--"}
        </span>
      ),
    },
    {
      dataField: "phone_no",
      text: "Phone No",
      formatter: (_, row) => (
        <span className="text-capitalize cursor-pointer">
          {row?.phone_no && row?.country_code
            ? `${row.country_code} ${row.phone_no}`
            : "--"}
        </span>
      ),
    },
    {
      dataField: "chemist_code",
      text: "Chemist Code",
      formatter: (_, row) => (
        <span className="text-capitalize cursor-pointer">
          {row.chemist_code}
        </span>
      ),
    },
    {
      text: "Created At",
      dataField: "createdAt",
      formatter: (_, row) => DATE_FORMAT(row.createdAt),
    },
    {
      text: "Unarchive",
      dataField: "",
      formatter: (_, row) => (
        <>
          <span className="d-flex gap-1">
            <button
              style={{
                fontSize: "20px",
                color: "red",
                backgroundColor: "#fff",
                border: "none",
              }}
              title="delete"
              onClick={() => unarchiveHandler(row?.id)}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.3"
                  d="M5 19H19V8H5V19ZM12 10L16 14H13.45V17H10.54V14H8L12 10Z"
                  fill="black"
                />
                <path
                  d="M20.54 5.23L19.15 3.55C18.88 3.21 18.47 3 18 3H6C5.53 3 5.12 3.21 4.84 3.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V6.5C21 6.02 20.83 5.57 20.54 5.23ZM6.24 5H17.76L18.59 6H5.42L6.24 5ZM19 19H5V8H19V19ZM10.55 17H13.45V14H16L12 10L8 14H10.55V17Z"
                  fill="black"
                />
              </svg>
            </button>
          </span>
        </>
      ),
    },
  ];
};

export default Columns;
